import { UzEmptyState, UzPageHeader } from '@utazzo/ui';

/**
 * Shared placeholder for nav routes whose real pages land once we have the
 * schema. Keeps the demo navigable without polluting the codebase with
 * one-line files per page.
 */
interface PlaceholderPageProps {
  title: string;
  message?: string;
}

export const PlaceholderPage = ({ title, message }: PlaceholderPageProps): React.JSX.Element => (
  <div className="space-y-6">
    <UzPageHeader title={title} />
    <UzEmptyState
      title="Coming soon"
      description={message ?? 'This area becomes functional once the data model is finalized.'}
    />
  </div>
);
